<template>
  <div class="brand-dealer">
    <div class="brand-top" v-if="brandInfo">
      <!-- <div class="brand-title">{{brandInfo.name}}</div> -->
      <img :src="brandInfo.picUrl" alt="">
    </div>
    <!-- <div class="brand-name">{{brandInfo.name}}</div> -->

    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
      <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="1">
        <div class="item-box" v-if="brandList">
          <van-row class="list">
            <itemInfo @navDetail="navToDetail" v-for="(itemInfo,index) in brandList" :key="index" :itemInfo="itemInfo"></itemInfo>

          </van-row>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import itemInfo from "@/components/itemInfo";

import { brandDetail, brandGoodsList } from "@/api/index";
import { Toast, Dialog } from "vant";

export default {
  name: "brandDealer",
  components: {
    itemInfo
  },
  data() {
    return {
      brandInfo: null,
      brandList: [],
      isLoading: true,
      loading: false,
      finished: false,
      data: {
        brandId: this.$route.query.id,
        page: 0,
        size: 10
      }
    };
  },
  mounted() {
    brandDetail(this.$route.query.id).then(res => {
      console.log(res);
      if (res.data.errno == 0) {
        this.brandInfo = res.data.data.brand;
      } else {
        Dialog.alert({
          title: "提示",
          message: res.data.errmsg
        });
      }
    });
    const nextPaging = {
      brandId: this.data.brandId,
      page: this.data.page + 1,
      size: 10
    };
    this.data = nextPaging;
    this.getBrandGoodsList(this.data);
  },
  methods: {
    onRefresh() {
      Toast("刷新成功");
      setTimeout(() => {
        this.isLoading = false;
        this.brandList = [];
        this.data = {
          brandId: this.data.brandId,
          page: 0,
          size: 10
        };
        this.finished = false;
      }, 500);
      // this.onLoad();
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        const nextPaging = {
          brandId: this.data.brandId,
          page: this.data.page + 1,
          size: 10
        };
        this.data = nextPaging;
        this.getBrandGoodsList(this.data);
      }, 500);
    },
    getBrandGoodsList(data) {
      brandGoodsList(data).then(res => {
        console.log(res);
        if (res.data.errno == 0) {
          let newOfRes = JSON.parse(JSON.stringify(res.data.data));
          this.brandList = this.brandList.concat(newOfRes.goodsList);
          this.loading = false;
          // // 数据全部加载完成
          if (this.brandList.length == newOfRes.count) {
            this.finished = true;
          }
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg
          });
        }
      });
    },
    navToDetail(id) {
      console.log(id);
      this.$router.push({
        path: "/type/detail",
        name: "商品详情",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.brand-dealer {
  height: 100%;
  background: #fff;
  overflow-y: scroll;
  .brand-top {
    position: relative;
    .brand-title {
      position: absolute;
      top: 30%;
      text-decoration: underline;
      width: 100%;
      left: 50%;
      margin-left: -50%;
      color: #fff;
      font-size: 1.8rem;
    }
    img {
      width: 100%;
      height: auto;
    }
  }
  .brand-name {
    height: 3rem;
    line-height: 3rem;
  }
}
.item-box {
  width: 100%;
  padding-bottom: 1rem;

  .list {
    width: 100%;
    margin: 0 auto;
  }
}
/deep/ .van-pull-refresh__head {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/view/index/brandDealer.vue